/** Messages several audio tools show for the same situation, kept in one place so they read the same everywhere. */

/** A file will not load as audio. Choosing a file spends no trial use, so the message says so. */
export const UNREADABLE_AUDIO_MESSAGE = "Couldn't read this audio file. It may be damaged or not audio. Nothing was used from your trial.";
/** A video loaded that has no sound track. */
export const NO_AUDIO_TRACK_MESSAGE = "This video has no audio track.";
